// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var CommonTypes_Jwt = require("../CommonTypes_Jwt.bs.js");
var CommonTypes_Guid = require("../CommonTypes_Guid.bs.js");
var CommonTypes_PhoneNumber = require("../CommonTypes_PhoneNumber.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.jwt;
  var value$2 = value.phoneNumber;
  var value$3 = value.signupKey;
  return {
          jwt: !(value$1 == null) ? Caml_option.some(CommonTypes_Jwt.GraphQL_API.parse(value$1)) : undefined,
          phoneNumber: !(value$2 == null) ? CommonTypes_PhoneNumber.GraphQL_API.parse(value$2) : undefined,
          signupKey: !(value$3 == null) ? Caml_option.some(CommonTypes_Guid.GraphQL_API.parse(value$3)) : undefined
        };
}

function serialize(value) {
  var value$1 = value.signupKey;
  var signupKey = value$1 !== undefined ? CommonTypes_Guid.GraphQL_API.serialize(Caml_option.valFromOption(value$1)) : null;
  var value$2 = value.phoneNumber;
  var phoneNumber = value$2 !== undefined ? CommonTypes_PhoneNumber.GraphQL_API.serialize(value$2) : null;
  var value$3 = value.jwt;
  var jwt = value$3 !== undefined ? Curry._1(CommonTypes_Jwt.GraphQL_API.serialize, Caml_option.valFromOption(value$3)) : null;
  return {
          jwt: jwt,
          phoneNumber: phoneNumber,
          signupKey: signupKey
        };
}

function verifyArgsAndParse(_CommonTypes_Business_LoginOrSignupResult, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var query = "fragment CommonTypes_Business_LoginOrSignupResult on BusinessLoginOrSignupResult   {\njwt  \nphoneNumber  \nsignupKey  \n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
/* CommonTypes_Jwt Not a pure module */
